import { app } from '../../../../../app';
import { Controller } from './app-key-password.controller';

app.component('companyManageApplicationIntegrationDevelopersAppKeyPassword', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./app-key-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/app-key-password/app-key-password.component.js